/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import React, { Component } from 'react';
import AgGridReactComponent from '../../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../../shared/services/common-functions';

const showInf = value => {
    if ( Number( value ) > 99999 ) return 'Inf';
    return value;
};

function displayRow ( tempResult, bundleCapacity, maxPercent ) {

    if ( tempResult.forecast !== undefined ) {

        if ( ( !bundleCapacity && tempResult.forecast === 0 ) ||
         ( bundleCapacity && tempResult.capacity === 0 ) ) {

            return !( ( bundleCapacity === false && tempResult.maxQty === 9999999
                && tempResult.flexQty === 999999 ) );

        }
        const percent = ( bundleCapacity === true ) ? ( ( ( tempResult.order /
            tempResult.capacity ) * 100 ) + 0.49 ) :
            ( ( ( tempResult.order /
                tempResult.forecast ) * 100 ) + 0.49 );
        return !( percent < ( Number( maxPercent ) + 1 ) );

    }
    if ( tempResult.order !== undefined ) {

        return true;

    }
    return false;

}

const excelStyles = [
    {
        id: 'greenBackground',
        interior: {
            color: '#b5e6b5',
            pattern: 'Solid'
        }
    },
    {
        id: 'centerText',
        alignment: {
            horizontal: 'Center'
        }
    },
    {
        id: 'redFont',
        font: {
            fontName: 'Calibri Light',
            underline: 'Single',
            italic: true,
            color: '#ff0000'
        }
    },
    {
        id: 'oddRowBackground',
        interior: {
            color: '#f7f7f7',
            pattern: 'Solid'
        }
    },
    {
        id: 'boldBorders',
        borders: {
            borderBottom: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderLeft: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderRight: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderTop: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            }
        }
    },
    {
        id: 'header',
        interior: {
            color: '#CCCCCC',
            pattern: 'Solid'
        },
        borders: {
            borderBottom: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderLeft: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderRight: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderTop: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            }
        }
    },
    {
        id: 'dateFormat',
        dataType: 'dateTime',
        numberFormat: { format: 'mm/dd/yyyy;@' }
    },
    {
        id: 'twoDecimalPlaces',
        numberFormat: { format: '#,##0.00' }
    },
    {
        id: 'textFormat',
        dataType: 'string'
    },
    {
        id: 'bigHeader',
        font: { size: 25 }
    },
    {
        id: 'regularHeader',
        font: { size: 14 }
    }
];

class BundleAllocationCapacityForecastTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

    }

    updateColumnDefs = params => {

        this.gridApi = params.api;

    }

    exportExcel = () => {

        const colKeys = this.gridApi.getAllGridColumns();
        const title = this.props.bundleCapacity === true ? 'Bundle Capacity Allocation' : 'Bundle Forecast Allocation';
        const generalParams = {
            fileName: title,
            sheetName: this.props.bundleCapacity === true ? 'Bundle Capacity Allocation' : 'Bundle Forecast Allocation',
            exportMode: 'xlsx',
            columnKeys: colKeys
        };

        this.gridApi.exportDataAsExcel( generalParams );

    };

    getColumnDefs = () => {

        const colDefs = [];
        let selectedWeekDate = '';
        colDefs.push(
            {
                headerName: 'Week Ending (Fiscal Month)',
                field: 'orderingCode',
                pinned: 'left',
                width: 250,
                filter: true,
                sortable: true,
                rowSpan: params => ( params.node.rowIndex % 2 === 0 ) ? 2 : 1,

                cellClassRules:
                {
                    'cell-span': params => params.value !== undefined,
                    'bkground-highlight': params => params.node.rowIndex % 4 === 0
                },
                cellRenderer: params => {

                    if ( params.value === '' ) {

                        return <span>{params.value}</span>;

                    }
                    return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=BN&constraintkey=${params.value}`}>{params.value}</Link> );

                }
            }
        );

        let i;
        for ( i = 0; i < this.props.weeks.length; i += 1 ) {

            if ( this.props.weeks[i].weekNumber === Number( this.props.selectedWeek ) ) {

                selectedWeekDate = this.props.weeks[i].weekEnding;

            }

        }
        const weekList = [];
        this.props.weeks.forEach( displayWeek => {

            const displayWeekInDateFormat = formatGivenDate( displayWeek.weekEnding, 'YYYY-MM-DD' );
            const selectedWeekInDateFormat = formatGivenDate( selectedWeekDate, 'YYYY-MM-DD' );

            if ( displayWeekInDateFormat === selectedWeekInDateFormat ||
            new Date( displayWeekInDateFormat ) < new Date( selectedWeekInDateFormat ) ) {

                let headerName = `${formatGivenDate( Number( displayWeek.weekEnding ), 'DDMMMYY' )}(${new Date( displayWeek.weekEnding ).getMonth() + 1})`;
                const dateField = formatGivenDate( Number( displayWeek.weekEnding ), 'YYYY-MM-DD' );

                if ( dateField === '2000-01-01' ) {

                    headerName = 'Inventory';

                } else if ( dateField === '2000-02-01' ) {

                    headerName = 'Rework';

                }

                colDefs.push(
                    {
                        headerName: `${headerName}`,
                        children: [
                            {
                                headerName: 'Ord',
                                field: `${displayWeek.weekEnding}_order`,
                                width: 90,
                                filter: true,
                                sortable: true,
                                cellClassRules:
                            {
                                'bkground-highlight': params => params.node.rowIndex % 4 === 0 || params.node.rowIndex % 4 === 1,
                                'bkground-clear': params => params.node.rowIndex % 4 === 2 || params.node.rowIndex % 4 === 3
                            },
                                colSpan: params => {

                                    const timestamp = ( params.colDef.field ).split( '_' )[0];
                                    const dataObj = params.data;
                                    const timestamporder = `${timestamp}_order`;
                                    const timestampfcst = `${timestamp}_ forecast`;
                                    if ( params.node.rowIndex % 2 === 0
                                     || ( params.node.rowIndex % 2 !== 0
                                    && dataObj[timestamporder] === undefined
                                    && dataObj[timestampfcst] === undefined ) ) {

                                        return 2;

                                    }
                                    return 1;

                                },
                                cellRenderer: params => {

                                    const timestamp = ( params.colDef.field ).split( '_' )[0];
                                    const dataObj = params.data;
                                    const timestamppercentage = `${timestamp}_ percentage`;
                                    const timestamporder = `${timestamp}_order`;
                                    const timestampfcst = `${timestamp}_ forecast`;
                                    const timestampcap = `${timestamp}_ capacity`;
                                    let classn = '';

                                    if ( params.node.rowIndex % 2 === 0 ) {

                                        const percentage = dataObj[timestamppercentage] !== undefined ? `${dataObj[timestamppercentage]}%` : '';
                                        if ( Number( dataObj[timestamppercentage] ) >
                                         Number( this.props.red )
                                        || dataObj[timestampcap] === 0
                                        || dataObj[timestampfcst] === 0 ) {

                                            classn = 'red';

                                        }
                                        if ( Number( dataObj[timestamppercentage] ) <
                                         Number( this.props.blue ) &&
                                         !( dataObj[timestampfcst] === undefined
                                         && dataObj[timestamporder] !== undefined ) ) {

                                            classn = 'blue';

                                        }
                                        return <span className={classn}>{percentage}</span>;

                                    }
                                    if ( ( params.node.rowIndex % 2 !== 0
                                    && dataObj[timestamporder] === undefined
                                    && dataObj[timestampfcst] === undefined ) ) {

                                        return '';

                                    }
                                    return ( <span>{dataObj[timestamporder] ? <Link to={`/${params.data.unitName}/constraints/check-orders-by-constraint-build-weeks?constrainttype=BN&constraintkey=${params.data.orderingCode}&beginweek=${formatGivenDate( Number( timestamp ), 'YYYY-MM-DD' )}&endweek=${formatGivenDate( Number( timestamp ), 'YYYY-MM-DD' )}`}>{dataObj[timestamporder]}</Link> : ''}</span> );

                                }
                            },
                            {
                                headerName: ( this.props.bundleCapacity === true ? 'Cap' : 'Fcst' ),
                                field: ( this.props.bundleCapacity === true ? `${displayWeek.weekEnding}_ capacity` : `${displayWeek.weekEnding}_ forecast` ),
                                width: 90,
                                filter: true,
                                sortable: true,
                                valueFormatter: params => showInf( params.value ),
                                cellClassRules:
                            {
                                'bkground-highlight': params => params.node.rowIndex % 4 === 0 || params.node.rowIndex % 4 === 1,
                                'bkground-clear': params => params.node.rowIndex % 4 === 2 || params.node.rowIndex % 4 === 3
                            }
                            }
                        ]
                    }
                );
                weekList[displayWeek.weekEnding] = displayWeek.weekEnding;

            }

        } );

        return colDefs;

    };

getTableResult = () => {

    const tableResult = [];
    if ( this.props.results !== null && this.props.results.length > 0 ) {

        this.props.results.forEach( tempResult => {

            let showRecord = false;
            const nestedTableResult = [];

            nestedTableResult.orderingCode = tempResult.orderingCode;
            nestedTableResult.unitName = tempResult.unitName;

            Object.keys( tempResult.capacityOrdDetails ).forEach( item => {

                if ( showRecord === true || displayRow( tempResult.capacityOrdDetails[item],
                    this.props.bundleCapacity, this.props.red ) ) {

                    showRecord = true;
                    nestedTableResult[`${item}_order`] = tempResult.capacityOrdDetails[item].order;

                    nestedTableResult[`${item}_ capacity`] = tempResult.capacityOrdDetails[item].capacity;

                    nestedTableResult[`${item}_ forecast`] = tempResult.capacityOrdDetails[item].forecast;

                    nestedTableResult[`${item}_ maxQnty`] = tempResult.capacityOrdDetails[item].maxQnty;

                    nestedTableResult[`${item}_ flexQnty`] = tempResult.capacityOrdDetails[item].flexQnty;

                    if ( ( this.props.bundleCapacity && Number( nestedTableResult[`${item}_ capacity`] ) > 99999 ) || ( !this.props.bundleCapacity && Number( nestedTableResult[`${item}_ forecast`] ) > 99999 ) ) {

                        nestedTableResult[`${item}_ percentage`] = 0;

                    } else {

                        if ( this.props.bundleCapacity === true ) {

                            if ( nestedTableResult[`${item}_ forecast`] !== undefined ) {

                                if ( nestedTableResult[`${item}_ capacity`] === 0 ) {

                                    nestedTableResult[`${item}_ percentage`] = nestedTableResult[`${item}_order`] * 100;

                                } else {

                                    nestedTableResult[`${item}_ percentage`] = Math.round( ( ( nestedTableResult[`${item}_order`] / nestedTableResult[`${item}_ capacity`] ) * 100 ) + 0.49 );

                                }

                            } else if ( nestedTableResult[`${item}_order`] !== undefined ) {

                                nestedTableResult[`${item}_ percentage`] = nestedTableResult[`${item}_order`] * 100;

                            } else {

                                nestedTableResult[`${item}_ percentage`] = undefined;

                            }

                        }
                        if ( this.props.bundleCapacity === false ) {

                            if ( nestedTableResult[`${item}_ forecast`] !== undefined ) {

                                if ( nestedTableResult[`${item}_ forecast`] === 0 ) {

                                    nestedTableResult[`${item}_ percentage`] = nestedTableResult[`${item}_order`] * 100;

                                } else {

                                    nestedTableResult[`${item}_ percentage`] = Math.round( ( ( nestedTableResult[`${item}_order`] / nestedTableResult[`${item}_ forecast`] ) * 100 ) + 0.49 );

                                }

                            } else if ( nestedTableResult[`${item}_order`] !== undefined ) {

                                nestedTableResult[`${item}_ percentage`] = nestedTableResult[`${item}_order`] * 100;

                            } else {

                                nestedTableResult[`${item}_ percentage`] = undefined;

                            }

                        }

                    }

                }

            } );
            if ( showRecord === true ) {

                tableResult.push( nestedTableResult );
                tableResult.push( nestedTableResult );

            }

        } );

    }

    return tableResult;

};

render () {

    const columnDefs = this.getColumnDefs();
    const tableResult = this.getTableResult();

    return (
        <section className="atp-search-result-panel bundle-capacity-forecast-log-result-panel">

            <div key={`${this.props.red} ${this.props.blue}`} className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    suppressRowTransform={true}
                    columnDefs={columnDefs}
                    rowData={tableResult}
                    onGridReady={this.onGridReady}
                    onRowDataChanged={this.updateColumnDefs}
                    excelStyles={excelStyles}
                />
            </div>

        </section>
    );

}

}

BundleAllocationCapacityForecastTable.propTypes = {
    results: PropTypes.array.isRequired,
    bundleCapacity: PropTypes.bool,
    weeks: PropTypes.array.isRequired,
    selectedWeek: PropTypes.string.isRequired,
    red: PropTypes.string.isRequired,
    blue: PropTypes.string.isRequired
};
export default BundleAllocationCapacityForecastTable;
